<template>
  <div class="upload">
    <div class="title">上传图片</div>
    <div class="upload_img">
      <el-upload
        accept="image/png,image/gif,image/jpeg,image/bmp/"
        action="http://jsonplaceholder.typicode.com/posts/"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :before-upload="beforeUpload"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import URL from "../../api/index.js";
import axios from "axios";
export default {
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      aliyunOssToken: "",
      UserInfo: "",
      getSpaceinfo: "",
      nowTime: "",
    };
  },
  mounted() {
    //  this.Storageload();
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    this.getOssToken();
    this.nowTimes();
  },
  methods: {
    //获取上传通行证
    getOssToken() {
      var _self = this;
      this.$get(
        "https://api.rujiaowang.net/netlearn/Common/album_get_oss_key"
      ).then(function (res) {
        _self.aliyunOssToken = res;
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeUpload(file) {
      if (
        file.type === "image/jpeg" ||
        file.type === "image/gif" ||
        file.type === "image/png" ||
        (file.type === "image/bmp" && file.size / 1024 / 1024 < 2)
      ) {
        var filename = file.name;
        // var uploadname = file.name;
        var getSuffix = function (filename) {
          var pos = filename.lastIndexOf(".");
          var suffix = "";
          if (pos != -1) {
            suffix = filename.substring(pos);
          }
          return suffix;
        };
        filename =
          new Date().getTime() +
          Math.ceil(Math.random() * 10000) +
          getSuffix(filename);
        // console.log(filename);
        var _self = this;
        var formData = new FormData();
        //注意formData里append添加的键的大小写
        formData.append("key", _self.aliyunOssToken.dir + "space/" + filename); //存储在oss的文件路径
        formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid); //accessKeyId
        formData.append("policy", _self.aliyunOssToken.policy); //policy
        formData.append("Signature", _self.aliyunOssToken.signature); //签名
        //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
        formData.append("callback", _self.aliyunOssToken.callback); //policy
        formData.append("file", file);
        formData.append("success_action_status", 200); //成功后返回的操作码
        var url = _self.aliyunOssToken.host;
        var fileUrl =
          _self.aliyunOssToken.host +
          "/" +
          _self.aliyunOssToken.dir +
          file.name;
        var point = this;
        $.ajax({
          url: url,
          type: "POST",
          data: formData,
          // async: false,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            _self.addimg(data); //添加图片接口
          },
          error: function (data) {},
        });
        this.$message({
          message: "上传成功",
          center: true,
        });
      } else {
        this.$message({
          message: "请上传正确的图片格式",
          center: true,
        });
        return false;
      }
    },
    // 数据上报
    getRecordRjw(hh,url) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_photouploading",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的相册上传功能",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            photoaddress: url,
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    addimg(data) {
      this.data = data;
      let datatemp = {
        0: this.data.filename,
      };
      // 上传图片数据上报
      this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")),datatemp[0]);
      this.$post("https://api.rujiaowang.net/netlearn/Dynamic/addalbum", {
        token: this.UserInfo.token,
        spaceid: this.getSpaceinfo.space_id,
        album: JSON.stringify(datatemp),
      }).then((item) => {
        if (item.state == "0") {
          this.odd();
        }
      });
    },
    odd() {
      this.$emit("shuaxin", "wowowo");
    },
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      this.nowTime = year + "-" + month + "-" + date;
    },
    nowTimes() {
      this.timeFormate(new Date());
      setInterval(this.nowTimes, 1000);
      this.clear();
    },
    clear() {
      clearInterval(this.nowTimes);
      this.nowTimes = null;
    },
  },
};
</script>

<style lang="less" scoped>
.el-upload-list__item-delete i {
  display: none !important;
}
.upload {
  // overflow: hidden;
  div {
    // float: left;
    margin-right: 45px;
    cursor: pointer;
    font-size: 14px;
    color: #3c495c;
  }
  .title {
    font-size: 18px;
    color: #000;
    margin-bottom: 15px;
  }
}
</style>
